import { IS_EMPTY } from 'cargo-chief-commons';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const isValidMc = (mc: string): boolean => {
	if (IS_EMPTY(mc)) return false;
	let formattedMc = mc.toLowerCase().replace('mc', '');
	const MC_NUMBER_PATTERN = /^\d{6,}$/;
	return MC_NUMBER_PATTERN.test(formattedMc);
};

export const isValidDot = (dot: string): boolean => {
	if (IS_EMPTY(dot)) return false;
	const DOT_NUMBER_PATTERN = /^\d{7,}$/;
	return DOT_NUMBER_PATTERN.test(dot);
};

export const cleanMc = (mc: string): string => {
	if (IS_EMPTY(mc)) return mc;
	let formattedMc = mc.toLowerCase().replace('mc', '');
	return String(Number(formattedMc));
};

export const cleanDot = (dot: string): string => {
	if (IS_EMPTY(dot)) return dot;

	// Remove optional "dot" prefix, then remove spaces/hyphens
	const formatted = dot
		.toLowerCase()
		.replace(/^dot\s*[-\s]*/i, '')
		.replace(/[\s-]/g, '');

	// Keep zero-padding behavior consistent with cleanMc() (it collapses via Number)
	return String(Number(formatted));
};

export const isPaidCarrierPlan = (planName: string): boolean => {
	if (IS_EMPTY(planName)) return false;
	const normalizedPlan = planName.toUpperCase();
	const PAID_CARRIER_PLANS = ['CARRIER_PRO'];
	return PAID_CARRIER_PLANS.includes(normalizedPlan);
};

function toCleanString(v: unknown): string {
	return (v ?? '').toString().trim();
}

export function mcFormatValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const raw = toCleanString(control.value);
		if (!raw) return null; // optional field; group validator handles "at least one"

		// optional "mc" + optional spaces/hyphen, then 1-7 digits, nothing else
		const ok = /^(?:mc\s*[-\s]*)?\d{1,7}$/i.test(raw);
		return ok ? null : { mcFormat: true };
	};
}

export function dotFormatValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const raw = toCleanString(control.value);
		if (!raw) return null;

		// optional "dot" + optional spaces/hyphen, then 1-9 digits, nothing else
		const ok = /^(?:dot\s*[-\s]*)?\d{1,9}$/i.test(raw);
		return ok ? null : { dotFormat: true };
	};
}
